import * as React from "react";
import classNames from "classnames";

import { Typography, withStyles, Tooltip } from "@material-ui/core";
import Check from "@material-ui/icons/Check";
import { WBSStore } from "modules/WBS/WBSStore";
import { ERowType, EWBSView } from "common/enums";
import { observer } from "mobx-react";

const styles = (theme) => ({
  container: {
    height: "32px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#363637",
    padding: "0px 15px",
    marginBottom: "1px",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "#464646",
      "& > svg": {
        opacity: 1,
      },
    },
  },
  description: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 400,
    color: "rgba(255,255,255,0.87)",
    width: "calc(100% - 20px)",
    overflow: "hidden",
    whiteSpace: "nowrap" as any,
    textOverflow: "ellipsis",
    display: "block",
    cursor: "default",
  },
  link: {
    color: "rgba(0,194,255,0.6)",
    textDecoration: "underline",
  },
  checkIcon: {
    marginLeft: "auto",
    color: "#ABC200",
    fontSize: "18px",
    opacity: 0,
    cursor: "pointer",
    transition: "all 0.3s ease-in",
  },
});

type IProps = {
  description: string;
  descriptionLength: number;
  onClick: any;
  link?: Boolean;
  isRl?: Boolean;
  classes: any;
  openDialog: any;
};

@observer
class Activity extends React.Component<IProps> {
  render() {
    const {
      classes,
      description,
      descriptionLength,
      openDialog,
      onClick,
      link,
      isRl,
    } = this.props;
    return (
      <div className={classes.container}>
        {descriptionLength >= 30 ? (
          <Tooltip
            style={link && isRl ? { cursor: "pointer" } : {}}
            onClick={() => {
              if (link && isRl) {
                openDialog();
              }
            }}
            title={description}
          >
            <Typography
              component="span"
              className={classNames(classes.description, {
                [classes.link]: link,
              })}
            >
              {description}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            component="span"
            className={classNames(classes.description, {
              [classes.link]: link,
            })}
          >
            {description}
          </Typography>
        )}
        {WBSStore.tab === 0 &&
          WBSStore.currentTab === EWBSView.EAP &&
          WBSStore.isLoadingOperations === false &&
          WBSStore.selectedLine.index != -1 &&
          !(
            WBSStore.selectedLine.data &&
            WBSStore.selectedLine.data.modelMapFull &&
            WBSStore.selectedLine.data.rowType == ERowType.STAGE
          ) && <Check className={classes.checkIcon} onClick={onClick} />}
      </div>
    );
  }
}

export default withStyles(styles)(Activity);



// WEBPACK FOOTER //
// ./src/modules/activitySearch/components/layouts/Activity.tsx